import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./LeaderBoardUnit.css";
import placeholder from "../../../../assets/img/faceplaceholder.jpeg";
import { getUserInfo } from "../../../../utils";
import axios from "axios";



const LeaderBoardUnit = (props) => {
  let { operator,rank } = props;
  let { actual, ideal, perf, userId } = operator;
  let [opName,setOpName] = useState("-");
  let [opDP,setOpDP] = useState(placeholder);

  useEffect(async ()=>{
    let {data} = await axios.get(getUserInfo(userId));
    try{
      setOpName(data.profile.name);
      setOpDP(data.profile.picture);
    }catch(e){
      console.error("Leaderboard Unit, Unexpected API response",e)
    }
  },[])

  return (
    <>
      <div className="box box-default">
        <div className="box-body employeeDetails">
          <div className="employeeImg">
            <img src={opDP} alt="Operator Photo" />
          </div>
          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <tbody>
                <tr>
                  <th>Rank</th>
                  <td>{rank}</td>
                </tr>
                <tr>
                  <th>Operator</th>
                  <td>{opName}</td>
                </tr>
                <tr>
                  <th>Productivity</th>
                  <td>
                    <b>Ideal / Actual</b>
                    <br />
                    {ideal}/{actual}
                  </td>
                </tr>
                <tr>
                  <th>Efficiency</th>
                  <td>{perf}%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

LeaderBoardUnit.propTypes = {};

LeaderBoardUnit.defaultProps = {};

export default LeaderBoardUnit;
